// src/constants/colors.js
const PALETTE = {
    primary: "#1583d4",
    secondary: "#059669",
    accent: "#f59e0b",

    neutrals: {
        background: "#FFFFF0",
        surface: "#f9fafb",
        text: "#1f2937",
        muted: "#6b7280",
    },

    states: {
        success: "#10b981",
        warning: "#facc15",
        error: "#ef4444",
        info: "#3b82f6",
    },
};

module.exports = { PALETTE };
